import {Component, OnInit} from '@angular/core';
import {InsurableObjectService} from "../../../cross/user-insurance/api/user-added-insurance-api.service";
import {Router} from "@angular/router";
import {MessageHelper} from "../../../core/helper/message-helper";
import {AppMessageService} from "../../../core/service/app-message.service";

@Component({
  selector: 'user-insurances',
  templateUrl: './user-insurances.component.html',
})
export class UserInsurancesComponent implements OnInit {

  isInsurableObjectsAvailable: boolean | undefined;

  initialized: boolean = false;

  constructor(protected router: Router, protected insurableObjectService: InsurableObjectService,protected messageService: AppMessageService,) {
  }

  ngOnInit(): void {
    this.initComponent();

  }

  initComponent() {

    this.insurableObjectService.list().subscribe(res => {
      this.isInsurableObjectsAvailable = !!res.length;
      this.refreshComponent();
    }, error =>  {
      MessageHelper.showErrorMessage(error.error.data, this.messageService);
    })

  }

  refreshComponent() {
    this.initialized = true;
  }

  navigateToContacts() {
    this.router.navigate([`/ds/my-contracts/`]);
  }
}
